// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y4Tv","label":"styles_label__1VzVl"};